// Zona iklan Z1-Z6 — persis definisi di halaman Pesanan (OrdersPage/utils/ordersConstants.ts)
// Region keys = Meta adgeo location (search?type=adgeolocation&country_code=ID)

export interface AdZone {
  id: string;
  label: string;
  provinces: string[];
  regions: { key: string; name: string }[];
}

export const AD_ZONES: AdZone[] = [
  {
    id: 'Z1',
    label: 'Zona 1 — Pulau Jawa',
    provinces: ['Banten', 'DKI Jakarta', 'Jawa Barat', 'Jawa Tengah', 'DI Yogyakarta', 'Jawa Timur'],
    regions: [{ key: '4143', name: 'Banten' }, { key: '1664', name: 'Jakarta' }, { key: '1685', name: 'Jawa Barat' }, { key: '1666', name: 'Jawa Tengah' }, { key: '1669', name: 'Daerah Istimewa Yogyakarta' }, { key: '1667', name: 'Jawa Timur' }],
  },
  {
    id: 'Z2',
    label: 'Zona 2 — Pulau Bali',
    provinces: ['Bali'],
    regions: [{ key: '1662', name: 'Pulau Bali' }],
  },
  {
    id: 'Z3',
    label: 'Zona 3 — Sumatra 1',
    provinces: ['Sumatera Utara', 'Riau', 'Jambi', 'Sumatera Selatan', 'Lampung'],
    regions: [{ key: '1682', name: 'Sumatra Utara' }, { key: '1677', name: 'Riau' }, { key: '1665', name: 'Jambi' }, { key: '1687', name: 'Sumatra Selatan' }, { key: '1674', name: 'Lampung' }],
  },
  {
    id: 'Z4',
    label: 'Zona 4 — Sumatra 2',
    provinces: ['Sumatera Barat', 'Bengkulu'],
    regions: [{ key: '1681', name: 'Sumatra Barat' }, { key: '1663', name: 'Bengkulu' }],
  },
  {
    id: 'Z5',
    label: 'Zona 5 — Ongkir Regular',
    provinces: ['Aceh', 'Kepulauan Riau', 'Bangka Belitung', 'Nusa Tenggara Barat', 'Kalimantan Barat', 'Kalimantan Tengah', 'Kalimantan Selatan', 'Kalimantan Timur', 'Sulawesi Utara', 'Sulawesi Tengah', 'Sulawesi Selatan', 'Sulawesi Tenggara', 'Gorontalo', 'Sulawesi Barat'],
    regions: [{ key: '1661', name: 'Aceh' }, { key: '4145', name: 'Kepulauan Riau' }, { key: '4144', name: 'Bangka-Belitung Islands' }, { key: '1675', name: 'Nusa Tenggara Barat' }, { key: '1670', name: 'Kalimantan Barat' }, { key: '1672', name: 'Kalimantan Tengah' }, { key: '1671', name: 'Kalimantan Selatan' }, { key: '1673', name: 'Kalimantan Timur' }, { key: '1686', name: 'Sulawesi Utara' }, { key: '1679', name: 'Sulawesi Tengah' }, { key: '1678', name: 'Sulawesi Selatan' }, { key: '1680', name: 'Sulawesi Tenggara' }, { key: '4142', name: 'Gorontalo' }, { key: '4141', name: 'Sulawesi Barat' }],
  },
  {
    id: 'Z6',
    label: 'Zona 6 — Diblokir',
    provinces: ['Papua', 'Papua Barat', 'Papua Selatan', 'Papua Tengah', 'Papua Pegunungan', 'Papua Barat Daya', 'Maluku', 'Maluku Utara', 'Nusa Tenggara Timur', 'Kalimantan Utara'],
    regions: [{ key: '1668', name: 'Papua' }, { key: '4140', name: 'Papua Barat' }, { key: '1683', name: 'Maluku' }, { key: '4138', name: 'Maluku Utara' }, { key: '1676', name: 'Nusa Tenggara Timur' }, { key: '4139', name: 'Kalimantan Utara' }],
  },
];

export const ZONE_IDS = AD_ZONES.map(z => z.id);

// Zona Z5/Z6 (Regular/Diblokir) tidak mendukung COD — sinkron dgn wa-cuanmax/utils/codSupport.js
// + trigger DB set_order_zone(). COD support = Z1-Z4. Match substring utk nama ibnux
// ("Kepulauan Bangka Belitung" → "Bangka Belitung").
const NO_COD_ZONES = new Set(['Z5', 'Z6']);

export function isNoCodZoneProvince(province?: string | null): boolean {
  if (!province) return false;
  const p = province.trim().toLowerCase();
  return AD_ZONES.some(z => NO_COD_ZONES.has(z.id) && z.provinces.some(pp => p.includes(pp.toLowerCase())));
}

export function zonesToRegions(ids: string[]): { key: string; name: string }[] {
  const set = new Map<string, { key: string; name: string }>();
  for (const id of ids) {
    const zone = AD_ZONES.find(z => z.id === id);
    for (const r of zone?.regions || []) set.set(r.key, r);
  }
  return [...set.values()];
}
